
<ng-template #convalidaTemplate>
   <div class="container-target">
      <div class="bg-white">
         <div class="mt-3">
            <div class="mx-auto">
               <div class="px-4 sm:px-6 lg:px-8">
                  <div class="grid grid-cols-12 p-0 w-full mx-auto my-3">
                     <div class="col-span-6">

                        <mat-form-field class="col-span-6 lg:col-span-4" appearance="fill">
                           <mat-label>Cerca un prodotto</mat-label>
                           <input matInput placeholder="" [(ngModel)]="filter" (ngModelChange)="filter = $event.toLowerCase()">
                        </mat-form-field>

                     </div>

                     <div class="col-span-6 text-right">
                        <button type="button" class="inline-flex items-center justify-center ds-btn ds-btn-info mx-3"
                                [disabled]="!prodForm.valid"
                                *ngIf="!ordine?.data?.is_convalida_chiusa" (click)="openPopup(false)">
                           Convalida
                        </button>

                        <button type="button" class="ds-btn ds-btn-outline ds-btn-info inline-flex items-center justify-center mx-3"
                                *ngIf="!ordine?.data?.is_convalida_chiusa" (click)="openPopup(true)">
                           Convalida Tutto
                        </button>
                     </div>
                  </div>

                  <div class="flex flex-col">
                     <div class="-my-0 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                           <div class="overflow-hidden ring-1 ring-black ring-opacity-5">
                              <form [formGroup]="prodForm">
                                 <table class="min-w-full divide-y divide-gray-300 tbl-header-dark">
                                    <thead>
                                    <tr>
                                       <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">Prodotto</th>
                                       <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">EAN</th>
                                       <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold">Riga</th>
                                       <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold">Taglia</th>
                                       <th scope="col" class="px-3 py-3.5 text-right text-sm font-semibold">QTA</th>
                                       <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold">Stato</th>
                                       <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">Ricevuto</th>
                                    </tr>
                                    </thead>
                                    <tbody class="divide-y divide-gray-200 bg-white">
                                    <tr *ngFor="let p of ordiniSlave; let i = index" formArrayName="prodotti" [hidden]="shouldHide(p)">
                                       <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                          <div class="text-gray-900">{{p.PROD_DISPLAY}}</div>
                                       </td>
                                       <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-left">{{p.data.ean}}</td>
                                       <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{p.data.riga}}</td>
                                       <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">
                                          {{p.data.vendor_prod_var_instance.metrica_str}}
                                       </td>
                                       <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-right">{{p.data.qta}}</td>
                                       <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-center" style="width: 150px">
                                          <div class="w-full bg-gray-200 rounded-full">
                                             <div class="text-xs font-bold text-center p-0.5 leading-none rounded-full"
                                                  [ngClass]="{
                                                     'bg-red-600': p.data.qta_convalidata! > p.data.qta!,
                                                     'bg-green-600': p.data.qta_convalidata! == p.data.qta!,
                                                     'bg-yellow-400': p.data.qta_convalidata! < p.data.qta!,
                                                     'text-black': p.data.qta_convalidata! <= p.data.qta!,
                                                     'text-red-100': p.data.qta_convalidata! > p.data.qta!
                                                  }"
                                                  [style.width]="p.data.percentage + '%'">{{p.data.qta_convalidata}}</div>
                                          </div>
                                       </td>
                                       <td class="whitespace-nowrap px-3 py-2 text-sm text-gray-500 text-left" [formGroupName]="i">
                                          <input #inputQta type="number" matInput class="text-right" formControlName="qta" min="0" max="{{p?.data?.qta_rimanente | number}}" step="1" (change)="checkQta(inputQta.value, p.data.qta_rimanente!)">
                                          <span matSuffix> / {{p.data.qta_rimanente | number}}</span>
                                       </td>
                                    </tr>
                                    </tbody>
                                 </table>
                              </form>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</ng-template>

<!--Modal convalida ricezione-->
<app-convalida-ricezione *ngIf="popupVisible" [popupVisible]="popupVisible"
                         (clickConfirm)="convalidaClick($event)"
                         (clickCancel)="popupVisible = false">
</app-convalida-ricezione>


<dx-popup
   [width]="'400'"
   [height]="'auto'"
   [showTitle]="true"
   title="Modifica DDT"
   [dragEnabled]="false"
   [hideOnOutsideClick]="false"
   [showCloseButton]="true"
   [(visible)]="popupModConvVisible">

   <mat-card class="example-result-card">
      <mat-card-content>
         <h6>{{ordineSlave.PROD_DISPLAY}}</h6>
         <div class="example-label-container">
            <label id="example-name-label" class="example-name-label">Prodotti ricevuti</label>
            <label class="example-value-label">{{qta}} / {{ordineSlave.data.qta}}</label>
         </div>
         <mat-slider
            class="example-margin my-5"
            [max]="ordineSlave.data.qta"
            [min]="0"
            [step]="1"
            [value]="qta"
            thumbLabel
            [displayWith]="formatLabel"
            (change)="updateSetting($event)"
         >
            <input matSliderThumb [(ngModel)]="qta">

         </mat-slider>
      </mat-card-content>
      <button type="button" class="mx-2 inline-flex items-center justify-center btn-conferma" (click)="clickModificaConvalide()">Conferma</button>
   </mat-card>

</dx-popup>
